export default __webpack_public_path__ + "static/media/dockerlogo.54cefa65.svg";